(function($){

    $(document).ready(function () {

        // Initiate aos animations
        AOS.init();


        // Remove empty paragraphs
        $('p:empty:not([role])').remove();


        // Remove p tags around images when using the WYSIWYG advanced custom field
        $('p > img').unwrap();

    });

})(jQuery);